import { Component } from "react";
import { compose } from "redux";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import SystemInit from "./Browser.System.Init.Component";
import SystemMaintenance from "./Browser.System.Maintenance.Component";
import SystemRestart from "./Browser.System.Restart.Component";
import EventBrowser from "./Browser.Event.Browser.Component";
import SystemCredits from "./Browser.System.Credits.Component";

import { browserConnector } from "../../../services/browser/connector";

class BrowserComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 0 };
  }

  handleChangeTab = (event, newValue) => this.setState({ activeTab: newValue });

  render() {
    let tabsArray = [];
    let isDev = import.meta.env.MODE === "development";

    if (isDev)
      tabsArray.push(<Tab label="Event browser" key="browser-1" value={1} />);

    if (isDev)
      tabsArray.push(<Tab label="Event browser" key="browser-2" value={2} />);

    tabsArray.push(<Tab label="Maintenance" key="browser-3" value={0} />);

    if (isDev) tabsArray.push(<Tab label="Init" key="browser-4" value={3} />);
    if (isDev)
      tabsArray.push(<Tab label="Restart" key="browser-5" value={4} />);
    if (isDev)
      tabsArray.push(
        <Tab label="Migrated Credit Info" key="browser-6" value={5} />,
      );

    return (
      <div className="browser-layout body-height">
        <Tabs value={this.state.activeTab} onChange={this.handleChangeTab}>
          {tabsArray}
        </Tabs>
        {this.state.activeTab === 0 && (
          <div className="content-padding">
            <SystemMaintenance {...this.props} />
          </div>
        )}
        {this.state.activeTab === 1 && (
          <div className="content-padding">
            <EventBrowser {...this.props} />
          </div>
        )}
        {this.state.activeTab === 2 && (
          <div className="content-padding">
            <EventBrowser {...this.props} />
          </div>
        )}
        {this.state.activeTab === 3 && (
          <div className="content-padding">
            <SystemInit {...this.props} />
          </div>
        )}
        {this.state.activeTab === 4 && (
          <div className="content-padding">
            <SystemRestart {...this.props} />
          </div>
        )}
        {this.state.activeTab === 5 && (
          <div className="content-padding">
            <SystemCredits {...this.props} />
          </div>
        )}
      </div>
    );
  }
}

export const Browser = compose(browserConnector)(BrowserComponent);
